export default function generateHexColorFromString(str: string): string {
  let hash = 0;

  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xff;
    color += ('00' + value.toString(16)).substr(-2);
  }

  return color;
}

export function getTextColor(hexColor: string): string {
  // Remove the "#" prefix and convert the color to RGB values
  const hex = hexColor.slice(1);
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  // Calculate the perceived brightness of the color using the YIQ formula
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;

  // If the brightness is closer to white, return black. Otherwise, return white.
  return brightness > 150 ? '#333333' : '#FFFFFF';
}
